import React, { useState, useRef } from "react";
import SimpleReactValidator from 'simple-react-validator';

import Bg2 from "../common/Bg2";
import { withRouter } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Helemt from "react-helmet";
import { loginUser } from "../../services/useService";

import { useAuth } from "../../contexts/AuthProvider";
import { supabase } from "../../utils/supabaseClient";

const Login = ({ history }) => {

    const { signIn, user } = useAuth();
    // const [name, setname] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");

    const getProfiles = async () => {

        let { data } = await supabase
            .from('profiles')
            .select(`username`)
            .eq('id', user.id)
            .single()

    }
    const loginUser = (e) => {
        e.preventDefault();
        try {
            signIn({ email, password });
            toast.success("ورود با موفقیت انجام شد", {
                position: toast.POSITION.TOP_CENTER
            });
            history.push("/userprofile");
            getProfiles()


        } catch (error) {

            toast.error("مشکلی پیش آمده", {
                position: toast.POSITION.TOP_CENTER
            });
        }

    }





    const [, forceUpdate] = useState("");

    const validator = useRef(
        new SimpleReactValidator({
            messages: {
                required: "پر کردن این فیلد الزامی میباشد",
                min: "کمتر از 5 کاراکتر نباید باشد",
                email: "ایمیل نوشته شده صحیح نمی باشد"
            },
            element: message => <div style={{ color: "red" }}>{message}</div>
        })
    );




    return (


        <div className="landing-layer" style={{ background: "none" }}>
            <ToastContainer rtl={true} theme="dark" />
            <Bg2 />
            <Helemt>
                <title> ماه کورس | ورود به سایت </title>
            </Helemt>
            <main className="client-page">

                <div className="container-content">
                    <header>
                        <h2 style={{ textShadow: "none", color: "black" }}> ورود به سایت </h2>
                    </header>

                    <div className="form-layer">

                        <form onSubmit={(e) => loginUser(e)}
                            style={{ background: "#ffffff" }}>

                            <div className="input-group">
                                <span
                                    className="input-group-addon"
                                    id="email-address"
                                >
                                    <i className="zmdi zmdi-email"></i>
                                </span>
                                <input
                                    type="text"
                                    name="email"
                                    className="form-control"
                                    placeholder="ایمیل"
                                    aria-describedby="email-address"
                                    value={email}
                                    onChange={e => {
                                        setEmail(e.target.value);
                                        validator.current.showMessageFor("email");
                                    }}
                                />
                            </div>
                            {validator.current.message("email", email, "required|email")}
                            <div className="input-group">
                                <span className="input-group-addon" id="password">
                                    <i className="zmdi zmdi-lock"></i>
                                </span>
                                <input
                                    name="password"
                                    value={password}
                                    onChange={e => {
                                        setPassword(e.target.value);
                                        validator.current.showMessageFor("password")

                                    }}

                                    type="password"
                                    className="form-control"
                                    placeholder="رمز عبور "
                                    aria-describedby="password"
                                />
                            </div>
                            {validator.current.message("password", password, "required|min:5")}
                            <div className="remember-me">
                                <label>
                                    <input type="checkbox" name="" /> مرا بخاطر
                                    بسپار{" "}
                                </label>
                            </div>

                            <div className="link">
                                <a href="">
                                    {" "}
                                    <i className="zmdi zmdi-lock"></i> رمز عبور خود
                                    را فراموش کرده ام !
                                </a>
                                <a href="">
                                    {" "}
                                    <i className="zmdi zmdi-account"></i> عضویت در
                                    سایت{" "}
                                </a>
                            </div>

                            <button className="btn btn-success">
                                {" "}
                                ورود به سایت{" "}
                            </button>

                        </form>
                    </div>
                </div>

            </main>
        </div>

    );
};

export default withRouter(Login);
